export enum ADYEN_RESULT_CODE {
	AUTHORISED = "Authorised",
	REFUSED = "Refused",
	PENDING = "Pending",
	CANCELLED = "Cancelled",
	ERROR = "Error",
	RECEIVED = "Received",
}
